export class ZollerFocus {
  constructor(
    public hash?: string,
    public name?: string
  ) { }

  clone() {
    return new ZollerFocus (
      this.hash,
      this.name
    );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/zoller-focus.ts